import React, { useContext } from 'react';
import { getChartColorTokenValues } from '../../utils/getColorTokenValue';
import { RendererContext } from '../../../context';
var PlatformBarChart = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_barchart' */
    '@atlassian/visualization/charts').then(function (module) {
      return {
        default: module.BarChart
      };
    })
  );
});
var Title = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_barchart' */
    '@atlassian/visualization/charts').then(function (module) {
      return {
        default: module.BarChart.elements.Title
      };
    })
  );
});
var SubTitle = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_barchart' */
    '@atlassian/visualization/charts').then(function (module) {
      return {
        default: module.BarChart.elements.SubTitle
      };
    })
  );
});

/**
 * Excluded props:
 * - grid - does not work across all components
 * - showTableOption - does not work across all components and will be moved into a primitive
 * - showToolTip - does not work across all components
 * - children - we will not be supporting primitives/elements to compose the chart
 * - patterns
 * - isPatterned
 * - sort
 *
 * Limited props:
 * - xAccessor - only allow non function types
 * - yAccessor - only allow non function types
 * - colorAccessor - only allow non function types
 * - colors - only allow chart color tokens (color.chart.*)
 */

export var BarChart = function BarChart(props) {
  var _ref = props.forgeDoc.props,
    width = _ref.width,
    height = _ref.height,
    data = _ref.data,
    showBorder = _ref.showBorder,
    xAccessor = _ref.xAccessor,
    yAccessor = _ref.yAccessor,
    colorAccessor = _ref.colorAccessor,
    colors = _ref.colors,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var colorValues = getChartColorTokenValues(colors);

  // Stop viz components from being rendered in Prod Forge environment
  var _useContext = useContext(RendererContext),
    forgeEnvironment = _useContext.forgeEnvironment;
  if (forgeEnvironment === 'PRODUCTION') {
    throw new Error('EAP features are only accessible to users with EAP signup and not supported or recommended for use in production.');
  }
  return /*#__PURE__*/React.createElement(PlatformBarChart, {
    width: width,
    height: height ? height : 400,
    data: data,
    showBorder: showBorder,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    colorAccessor: colorAccessor,
    colors: colorValues
  }, title && /*#__PURE__*/React.createElement(Title, null, title), subtitle && /*#__PURE__*/React.createElement(SubTitle, null, subtitle));
};